<template>
    <v-app>
        <!-- <v-overlay :value="isLoading" z-index="300">
            <v-progress-circular
                indeterminate
                size="64"
                color="grey lighten-5"
            ></v-progress-circular>
        </v-overlay> -->

        <div v-if="chk_route == 2"><Survey /></div>
        <div v-if="chk_route == 1"><Timeatt /></div>
        <div v-if="chk_route == 3"><SearchCso /></div>
        <div v-if="chk_route == 4"><Tracking /></div>

        <div v-if="chk_route == 99">
            <Sidebar v-if="chk_token === true" />
            <Viewcontent v-if="chk_token === true" />
            <Login v-if="chk_token === false" @page_login="login()" />
        </div>
    </v-app>
</template>

<script>
import Sidebar from "./components/Sidebar"
import Viewcontent from "./components/Viewcontent"
import Login from "./components/Login"
import Timeatt from "./components/TimeAttendance"
import SearchCso from "./pages/Onsite/components/SearchCso.vue"
// import Timeatt from "./components/TimeAttendance_Backup"
import Survey from "./pages/HR/Covid/Survey"
import LuckyDay from "./test/seminar/index"
import Tracking from "./components/Tracking.vue"

import { mapState, mapMutations } from "vuex"

export default {
    name: "App",
    components: {
        Sidebar,
        Viewcontent,
        Login,
        Timeatt,
        LuckyDay,
        Survey,
        SearchCso,
        Tracking,
    },
    mounted() {
        // console.log(this.$route.name)
        if (this.$route.name == "TimeAtt") {
            this.chk_route = 1
        } else if (this.$route.name == "Survey") {
            this.chk_route = 2
        } else if (this.$route.name == "SearchCso") {
            this.chk_route = 3
        } else if (this.$route.name == "Tracking") {
            this.chk_route = 4
        } else {
            this.chk_route = 99
        }

        if (localStorage.token) {
            this.mutateToken()

            let date_a = new Date()
            let date = new Date(localStorage.storagetime)
            // let diffTime = Math.abs(date_a - date)
            // let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            let seconds = (date_a - date) / 1000

            // console.log(date_a, "--date")
            // console.log(date, "--local")
            // console.log(seconds)
            // console.log(diffTime, "--diffTime")
            // console.log(diffDays, "--diffDays")

            if (seconds > 0) {
                this.mutateToken()
            }
        }
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["chk_token"]),
    },
    methods: {
        ...mapMutations(["mutateToken"]),
        login() {
            this.mutateToken()
        },
    },
    data: () => ({
        chk_date: 0,
        chk_route: false,
        chk_route_name: "",
        test: false,
    }),
}
</script>
